import React from 'react';
import { Pagination } from '@/components/Pagination';
import { LoadingState } from './LoadingState';
import { MetricsGrid } from './MetricsGrid';
import { ViewsTable } from './ViewsTable';
import type { ReportMetrics, ReportViewItem } from '@/types/reports';

interface MetricsTabContentProps {
  metricsLoading: boolean;
  metrics: ReportMetrics | null;
  viewsData: { data: ReportViewItem[]; total: number } | null;
  viewsLoading: boolean;
  page: number;
  pageSize: number;
  onPageChange: (_page: number) => void;
}

export const MetricsTabContent: React.FC<MetricsTabContentProps> = ({
  metricsLoading,
  metrics,
  viewsData,
  viewsLoading,
  page,
  pageSize,
  onPageChange,
}) => {
  if (metricsLoading) {
    return <LoadingState message="Carregando métricas..." />;
  }

  const total = viewsData?.total ?? 0;

  return (
    <div className="space-y-6">
      <MetricsGrid metrics={metrics} />
      <ViewsTable
        data={viewsData?.data ?? []}
        total={total}
        loading={viewsLoading}
      />
      <Pagination
        currentPage={page}
        totalItems={total}
        pageSize={pageSize}
        onPageChange={onPageChange}
      />
    </div>
  );
};
